import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #e9ecef;
  padding: 12px;
  @media (min-width: 426px) {
    padding: 20px;
  }
`;

export const PanelTitle = styled.div`
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  margin-right: 10px;
  text-decoration: underline;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  & > * {
    /* margin-left: 10px; */
  }
`;
